// Actions to run when the router matches a route. Used in app/routes.js
import { loadEntertainer, loadWebsite, loadServices, loadHomeEntity, loadUserEntity, loadCategoryServices, loadProducts, loadWebsiteLanding, loadServicesentity, loadproductentity, loadprofileentity } from '../actions/WebsiteLoadCreator';
import {loadResultsPage, loadOffersPage} from '../actions/EntertainerLoadCreator';

const InitActions = {
  Categorypage(context, route, done) {
    const id = route.getIn(['params', 'id']);
    context.executeAction(loadCategoryServices, {
      id
    }, done);
  },
  Websitepage(context, route, done) {
    const id = route.getIn(['params', 'id']);
    context.executeAction(loadWebsite, {
      id
    }, done);
  },
  Websitelandingpage(context, route, done) {
    const id = route.getIn(['params', 'id']);
    context.executeAction(loadWebsiteLanding, {
      id
    }, done);
  },
  UserfavouritePage(context, route, done) {
    const id = route.getIn(['params', 'id']);
    var ids = id.split(',');
    context.executeAction(loadUserEntity, {
      ids
    }, done);
  },
  Homepage(context, route, done) {
    const id = route.getIn(['params', 'id']);
    context.executeAction(loadHomeEntity, {
      id
    }, done);
  },
  Servicepage(context, route, done) {
    const id = route.getIn(['params', 'id']);
    context.executeAction(loadServices, {
      id
    }, done);
  },
  Serviceentitypage(context, route, done) {
    const id = route.getIn(['params', 'id']);
    context.executeAction(loadServicesentity, {
      id
    }, done);
  },
  Productpage(context, route, done) {
    const id = route.getIn(['params', 'id']);
    context.executeAction(loadProducts, {
      id
    }, done);
  },
  Productentitypage(context, route, done) {
    const id = route.getIn(['params', 'id']);
    context.executeAction(loadproductentity, {
      id
    }, done);
  },
  UserProfilePage(context, route, done) {
    const id = route.getIn(['params', 'id']);
    context.executeAction(loadprofileentity, {
      id
    }, done);
  },
  SearchResults(context, route, done) {
  //  console.log("route d",roue);
    console.log("route",route.getIn(['params']));
   const params = route.getIn(['query']);
   var   inputparams = {
     id: params.getIn(['id']),
     nationality: params.getIn(['nationality']),
     age: params.getIn(['age']),
     gender: params.getIn(['gender'])
   };
   console.log("params result",inputparams);
  //  var id = 'service_1479371741364i6ptl6jtcieieal0ojnvobt9,service_14793717413644aiyspwhqt3785bm1mva1t6gvi,service_14793720861141oinq077xewlrjj3xh9lrtfbt9';
    context.executeAction(loadEntertainer,inputparams, done);
  },
  badPage(context, route, done) {
    const err = new Error();
    err.message = 'Do not worry, just giving a try.';
    done(err);
  },
  ResultsPage(context, route, done) {
    const id = route.getIn(['params', 'id']);
    context.executeAction(loadResultsPage, {
      id
    }, done);
  },
  getOffers(context, route, done) {
    const id = route.getIn(['params', 'id']);
    context.executeAction(loadOffersPage, {
      id
    }, done);
  },
};

export default InitActions;



// WEBPACK FOOTER //
// ./src/pages/InitActions.js